module.exports = __webpack_public_path__ + "img/card-rrhh-report.685ce13d.svg";